import {CommonReducer, ReducerFromState} from "../../@types/reducers";
import {FixtureObject} from "../../@types/response";

export const getSports = (state: ReducerFromState<CommonReducer>): FixtureObject => state.common.sports;
